import React from 'react';

const Component: React.FC = () => (
  <svg version='1.1' viewBox='0 0 512 512'>
    <g>
      <path
        d='M504.502,7.506c-13.98-13.979-38.096-7.733-63.658,13.036c-23.165,18.38-144.506,116.541-208.014,177.659
		c-44.26,38.524-78.696,76.056-86.28,103.851c-0.72,2.648-1.147,5.113-1.337,7.415l-32.121,32.127l-75.98,53.542
		c-1.82,1.29-3.516,2.723-5.078,4.284c-5.106,5.106-8.718,11.576-10.361,18.706L0,511.995l93.884-21.658
		c7.129-1.65,13.599-5.262,18.705-10.374c1.554-1.548,2.988-3.245,4.27-5.078l53.555-75.967l32.128-32.121
		c2.301-0.19,4.766-0.617,7.407-1.344c27.789-7.577,65.328-42.013,103.858-86.28C374.919,215.664,473.088,94.33,491.46,71.158
		C512.236,45.595,518.475,21.486,504.502,7.506z M102.745,464.931c-0.714,1.018-1.507,1.955-2.376,2.818
		c-2.832,2.831-6.416,4.84-10.368,5.75l-58.389,13.47l38.849-38.849c4.325,1.752,9.458,0.869,12.968-2.627
		c4.672-4.671,4.672-12.242,0-16.912c-4.678-4.671-12.248-4.671-16.919,0c-3.503,3.503-4.378,8.636-2.62,12.96L25.033,480.39
		l13.477-58.389c0.91-3.945,2.912-7.529,5.75-10.367c0.863-0.863,1.799-1.657,2.811-2.376l73.115-51.532l34.096,34.096
		L102.745,464.931z M160.258,384.639l-32.888-32.888l22.968-22.976c1.82,2.614,3.87,4.807,5.778,6.714l20.402,20.403
		c1.908,1.9,4.1,3.958,6.714,5.771L160.258,384.639z'
      />
    </g>
  </svg>
);

export default Component;
